<template>
<footer style="display: block;">
    <ul>
        <li><a href="http://www.chinasrcc.com/">公司官网</a></li>
        <li><a href="/download">下载中心</a></li>
        <li><a href="http://www.chinasrcc.com/1_21.html">资质证书</a></li>
        <li><a class="btn-open" href="https://app-m.huxiu.com?download=1">联系方式</a></li>
    </ul>
    <div class="copyright-box">
    ©<span class="js-foot-year">2019~2021</span> 上海轨道交通检测认证（集团）有限公司
    </div>
</footer>
<!--
    <div class="footer">
        <div class="footer-inner">
        <div class="Qrcode">
            <img :src='img1'>
            官方服务号
        </div>
        <section style="padding-right: 100px;">
            <div class="item">
                <div class="item-name">中国轨道交通检测技术有限公司：</div>
                <div class='item-value'>
                    <ul>
                        <li><a href="http://www.chinasrcc.com/1_3.html">发展历程</a></li>
                        <li><a href="http://www.chinasrcc.com/1_21.html">资质荣誉</a></li>
                        <li><a href="http://www.chinasrcc.com/7_1.html">联系我们</a></li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </section>
        <section style="padding-right: 100px;">
            <div class="item">
                <div class="item-name">地址：</div>
                <div class='item-value'>
                    上海市虹口区广粤支路87号
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">电话：</div>
                <div class='item-value'>
                    021-56556312
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">传真：</div>
                <div class='item-value'>
                    021-56551276
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">邮编：</div>
                <div class='item-value'>
                    200434
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="item">
                <div class="item-name">邮箱：</div>
                <div class='item-value'>
                    srcc@chinasrcc.com
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </section>
        <section>
            <div class="item-name">友情链接：</div>
            <div class='item-value'>
                <ul>
                    <li><a href="http://www.chinasrcc.com/">上海轨道交通检测有限公司</a></li>
                    <li><a href="http://samr.saic.gov.cn/">国家质检总局</a></li>
                    <li><a href="http://www.cnca.gov.cn/">中国国家认证认可监督管理委员会</a></li>
                    <li><a href="https://www.cnas.org.cn/">中国合格评定国家认可委员会</a></li>
                    <li><a href="http://www.ccaa.org.cn/">中国认证认可协会</a></li>
                    <li><a href="https://www.tongji.edu.cn/">同济大学</a></li>
                </ul>
            </div>
            <div class="clearfix"></div>
        </section>
        <section class='copyright'>
            <div>Copyright Centre Testing International All rights resereved 沪ICP备16013901号-2</div>
            <div><img :src="img2">沪公安网报备 44038882000441号</div>
        </section>
    </div>
    </div>
  <div class="innerbox">
            <div class="content">
                <dl>
                    <dt>公司介绍</dt>
                    <dd><a href="http://www.chinasrcc.com/1_3.html">发展历程</a></dd>
                    <dd><a href="http://www.chinasrcc.com/1_21.html">资质荣誉</a></dd>
                    <dd><a href="http://www.chinasrcc.com/7_1.html">联系我们</a></dd>
                </dl>
                <dl>
                    <dt>友情链接</dt>
                    <dd><a href="http://www.chinasrcc.com/">公司主页</a></dd>
                    <dd><a href="http://samr.saic.gov.cn/">国家质检总局</a></dd>
                </dl>
                <dl>
                    <dt>委托及报告</dt>
                    <dd>报告查询</dd>
                </dl>
                <div class="address">
                    <p class="footer-phone">电话：021-56556312</p>
                    <p class="footer-phone">传真：021-56551276</p>
                    <p>地址：上海市虹口区广粤支路87号</p>
                    <p>邮编：200434</p>
                    <p>邮箱：srcc@chinasrcc.com</p>
                </div>
            </div>
            <div class="buttom-remark">
                <div class="b-r-p"><span>Copyright Centre Testing International All rights reserved 沪ICP备16013901号-2</span></div>
                <div class="b-r-p"><span><img  class="b-r-img" src="../assets/gaicon.png"></span><span>沪公网安备 44038882000441号</span></div>
            </div>
        </div>-->

</template>

<script>
    export default {
        name: "footerBar",
        data() {
            return {
                img1: process.env.BASE_URL + "img/qrcode.png",
                img2: process.env.BASE_URL + "img/Bitmap.png",

            }
        },
        props: {

        },
        methods: {

        }
    }
</script>

<style scoped>
    footer {
    height: 7.5rem;
    width: 100%;
    background: #fff;
    text-align: center;
    color: #bbb;
}
footer ul {
    margin: 2.4rem auto .5rem auto;
    display: inline-block;
}
footer ul li {
    float: left;
    font-size: .7rem;
    line-height: 1;
    border-right: 1px solid #bbb;
}
footer ul li a {
    color: #bbb;
    margin-left: .5rem;
    margin-right: .5rem;
}
footer .copyright-box {
    font-size: .6rem;
}
footer ul li:last-child {
    border: none;
}
</style>